import React from 'react';
import { BsPlayCircle, BsGrid, BsPuzzle, BsTag, BsBook } from 'react-icons/bs';
import { ARTICLE_METADATA, ARTICLE_SLUGS } from '../../pages/learnMore/constants/articleMetadata';

export interface NavDropdownItem {
  title: string;
  description: string;
  href: string;
  icon: React.ComponentType<{ className?: string; size?: number }>;
  accentColor: string;
}

export const DROPDOWN_GAP = 16;

export const TOP_FEATURES_ITEMS: NavDropdownItem[] = [
  { title: 'Overview', description: 'See Olympiq in action with a video walkthrough', href: '/#overview', icon: BsPlayCircle, accentColor: '#8B5CF6' },
  { title: 'Features', description: 'Explore all the tools and capabilities', href: '/#features', icon: BsGrid, accentColor: '#EC4899' },
  { title: 'Integrations', description: 'Connect with the tools you already use', href: '/#integrations', icon: BsPuzzle, accentColor: '#14B8A6' },
  { title: 'Pricing', description: 'Simple, transparent pricing for your club', href: '/#pricing', icon: BsTag, accentColor: '#F59E0B' },
];

export const LEARN_MORE_ITEMS: NavDropdownItem[] = [
  { title: 'Knowledge Hub', description: 'Your guide to getting the most from Olympiq', href: '/learn-more', icon: BsBook, accentColor: '#6366F1' },
  ...ARTICLE_SLUGS.map((slug) => ({
    title: ARTICLE_METADATA[slug].title,
    description: ARTICLE_METADATA[slug].description,
    href: `/learn-more/${slug}`,
    icon: ARTICLE_METADATA[slug].Icon,
    accentColor: slug === 'customised-club-website' ? '#8B5CF6' :
                 slug === 'content-management' ? '#F43F5E' :
                 slug === 'club-mobile-app' ? '#10B981' :
                 slug === 'membership-management' ? '#3B82F6' :
                 slug === 'seamless-payments-refunds' ? '#475569' :
                 '#EAB308',
  })),
];
